// Locales supportées par la SPA (doit rester aligné avec config/i18n/index.ts).
export type SupportedLocale = 'fr-FR' | 'en-US'

const SUPPORTED_LOCALES: SupportedLocale[] = ['fr-FR', 'en-US']

// Codes courts (envoyés par certaines iframes, ex. ?lang=en) vers les locales supportées.
const SHORT_CODE_TO_LOCALE: { [key: string]: SupportedLocale } = {
  en: 'en-US',
  fr: 'fr-FR'
}

/**
 * Résout la locale à appliquer depuis le paramètre `lang` de l'URL.
 *
 * Accepte soit une locale complète déjà supportée (`en-US`, `fr-FR`), soit un
 * code court (`en`, `fr`). Renvoie `null` si le paramètre est absent ou inconnu :
 * l'appelant conserve alors la locale par défaut.
 *
 * Utilisé au démarrage (main.ts) pour appliquer la langue même en mode iframe
 * (`?withHeader=false`), où le sélecteur de langue du header n'est jamais monté.
 */
export function resolveLocaleFromQuery (rawLang: string | null): SupportedLocale | null {
  if (rawLang === null || rawLang === '') {
    return null
  }
  const directMatch = SUPPORTED_LOCALES.find(locale => locale === rawLang)
  if (directMatch !== undefined) {
    return directMatch
  }
  const mappedLocale = SHORT_CODE_TO_LOCALE[rawLang]
  if (mappedLocale !== undefined) {
    return mappedLocale
  }
  return null
}
